import { Avatar } from '@mui/material';
import React from 'react';

interface KenAvatarProps {
  classes: any;
  value?: string;
  src?: string;
}

const stringAvatar = (name: string) => {
  const nameParts = name.split(' ');
  const firstInitial = nameParts[0][0].toUpperCase();
  const secondInitial = nameParts[1]?.[0].toUpperCase() || ''; // Safely handle single name

  return {
    sx: {
      bgcolor: '#fff',
      color: '#5981FF',
    },
    children: `${firstInitial}${secondInitial}`, // Combine initials
  };
};

const KenAvatar: React.FC<KenAvatarProps> = ({ classes, value, src }) => {
  if (src) {
    return <img className={classes} alt="Avatar" src={src} />;
  } else if (value) {
    return <Avatar className={classes} {...stringAvatar(value)} />;
  } else {
    return <Avatar className={classes} />;
  }
};

export default KenAvatar;
